import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { SidebarLayout } from '../../components/Sidebar';
import { HellocianSidebarLayout } from '../../components/HellocianSidebar';
import { AdminSidebarLayout } from '../../components/AdminSidebar';
import DesktopMessaging from '../../components/shared/DesktopMessaging';
import MobileMessaging from '../../components/shared/MobileMessaging';
import { useAuthStore } from '../../store/authStore';

// This component brings together all messaging components
const Messaging = ({ sidebarComponent = null }) => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [selectedChatId, setSelectedChatId] = useState(chatId || null);
  const [showProfile, setShowProfile] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileView, setMobileView] = useState('list'); // 'list', 'chat', or 'profile'
  
  // Sync selectedChatId when URL param changes
  useEffect(() => {
    if (chatId) {
      setSelectedChatId(chatId);
      if (isMobile) {
        setMobileView('chat');
      }
    }
  }, [chatId, isMobile]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // Reset mobile view if switching between desktop and mobile
      if (!mobile && mobileView !== 'list') {
        setMobileView('list');
      }
    };
    
    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileView]);
  
  const handleSelectChat = (chatId) => {
    setSelectedChatId(chatId);
    
    // Determine base path for navigation
    const currentPath = window.location.pathname;
    const basePath = currentPath.split('/messages')[0] + '/messages';
    navigate(`${basePath}/${chatId}`);
    
    if (isMobile) {
      setMobileView('chat');
    }
  };
  
  const handleProfileView = (show) => {
    setShowProfile(show);
    if (isMobile && show) {
      setMobileView('profile');
    }
  };
  
  const handleBackToList = () => {
    setMobileView('list');
  };
  

  const { user } = useAuthStore();

  const renderContent = () => {
    if (isMobile) {
      return (
        <MobileMessaging 
          mobileView={mobileView} 
          handleBackToList={handleBackToList}
          handleSelectChat={handleSelectChat} 
          selectedChatId={selectedChatId} 
          handleProfileView={handleProfileView} 
        />
      );
    }

    return (
      <DesktopMessaging 
        sidebarComponent={sidebarComponent} 
        handleSelectChat={handleSelectChat}
        selectedChatId={selectedChatId} 
        handleProfileView={handleProfileView} 
        showProfile={showProfile} 
      />
    );
  };

  const layoutProps = {
    currentPath: '/messages'
  };

  if (user?.role === 'admin' || user?.role === 'super-admin') {
    return (
      <AdminSidebarLayout {...layoutProps}>
        {renderContent()}
      </AdminSidebarLayout>
    );
  }

  if (user?.role === 'hellocian') {
    return (
      <HellocianSidebarLayout {...layoutProps}>
        {renderContent()}
      </HellocianSidebarLayout>
    );
  }

  return (
    <SidebarLayout {...layoutProps}>
      {renderContent()}
    </SidebarLayout>
  );
};

export default Messaging;
